/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type LinkPlanDto = {
    /**
     * RevenueCat product identifier. Plans are created in App Store/Play Store; this links config to the product.
     */
    revenuecatProductId: string;
    /**
     * Platform commission percentage (0-100)
     */
    commissionPercentage?: number;
    /**
     * Who this plan is ideal for (e.g. Active experts (4-10 clients/month))
     */
    idealFor?: string;
    /**
     * Array of feature descriptions
     */
    features?: Array<string>;
    /**
     * Session limit (null = unlimited)
     */
    maxSessions?: number;
    /**
     * Sessions per week cap (null = unlimited)
     */
    sessionsPerWeek?: number;
    /**
     * Show "Most Popular" badge
     */
    isMostPopular?: boolean;
    /**
     * Admin toggle: plan visible/purchasable in app
     */
    isActive?: boolean;
    /**
     * Lifecycle state: active | inactive | grandfathered
     */
    planStatus?: LinkPlanDto.planStatus;
};
export namespace LinkPlanDto {
    /**
     * Lifecycle state: active | inactive | grandfathered
     */
    export enum planStatus {
        ACTIVE = 'active',
        INACTIVE = 'inactive',
        GRANDFATHERED = 'grandfathered',
    }
}

